module.exports = __webpack_public_path__ + "static/3-Tri-07-49613b4a0edea7582e7b27196966cde8.png";